import { FC } from 'react';
import { Icons, Theme } from 'team-hero-ui';
import { useTranslation } from 'react-i18next';

import {
  SuccessWrapper,
  ButtonStyled,
  DescriptionStyled,
} from './SuccessStep.styled';

interface ISuccessStepProps {
  resetForm: () => void;
}

const SuccessStep: FC<ISuccessStepProps> = ({ resetForm }) => {
  const { t } = useTranslation();
  return (
    <SuccessWrapper>
      <Icons.CheckIconV1 svgSize={128} svgColor={Theme.colors.primary.green} />
      <DescriptionStyled>
        {t('form:applyForm.successMessage')}
      </DescriptionStyled>
      <ButtonStyled
        color='black'
        size='large'
        type='button'
        onClick={() => {
          resetForm();
        }}
      >
        {t('button.back')}
      </ButtonStyled>
    </SuccessWrapper>
  );
};

export default SuccessStep;
